<script>
/* eslint-disable */
</script>
<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.name" placeholder="姓名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset();"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click.native="handleForm(null, null)">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" style="width: 100%;">
            <el-table-column label="ID" prop="investorId" fixed>
            </el-table-column>
            <el-table-column label="投资人姓名" prop="name" fixed>
            </el-table-column>
            <el-table-column label="手机" prop="phone" with="300" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="email" prop="email" fixed>
            </el-table-column>
            <el-table-column label="证件类型" prop="IDTypeName" fixed>
            </el-table-column>
            <el-table-column label="证件号码" prop="IDNumber" fixed>
            </el-table-column>

            <el-table-column label="更新时间" prop="createDate" fixed>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination :page-size="query.limit" @current-change="handleCurrentChange" layout="prev, pager, next"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="85%" top="5vh"
            :close-on-click-modal="false">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="投资人姓名" prop="name">
                    <el-input v-model="formData.name" auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="email" prop="email">
                    <el-input v-model="formData.email" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="phone" prop="phone">
                    <el-input v-model="formData.phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="证件类型" prop="IDTypeName">
                    <el-input v-model="formData.IDTypeName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="证件编号" prop="IDNumber">
                    <el-input v-model="formData.IDNumber" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="创建时间" prop="createDate">
                    <el-input v-model="formData.createDate" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
/* eslint-disable */
import {
    investorList,
    investorSaveOrEdit,
    investorDelete
} from "../../api/risk/investor";
import draggable from "vuedraggable";
import { Message } from "element-ui";

const formJson = {
    investorId: "",
    name: "",
    email:"",
    phone:"",
    IDTypeName:"",
    IDNumber:"",
};
export default {
    data() {
        return {
            query: {
                name: "",
                page: 1,
                limit: 20
            },
            list: [],
            adId: [],
            adSelectList: [],
            adList: {},
            adListNoDataText: "无数据",
            queryAdIdAsyncLoading: false,
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                add: "新增",
                edit: "编辑"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {
                siteName: [
                    {
                        required: true,
                        message: "请输入广告位名称",
                        trigger: "blur"
                    }
                ]
            },
            deleteLoading: false
        };
    },
    components: {
        draggable
    },
    methods: {
        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                investorId: "",
                page: 1,
                limit: 20
            };
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            investorList(this.query)
                .then(response => {
                    this.loading = false;
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // handleAdSubmit() {
        //     if (this.adSelectList.length === 0) {
        //         return false;
        //     }
        //     let ads = [];
        //     this.adSelectList.map(item => {
        //         if (this.adList.hasOwnProperty(item)) {
        //             ads.push(this.adList[item]);
        //         }
        //     });
        //     this.formData.ads = this.formData.ads.concat(ads);
        //     this.adList = {};
        //     this.adId = [];
        // },
        // handleAdClose(index) {
        //     this.formData.ads.splice(index, 1);
        // },
        // handleAdChange(item) {
        //     this.adSelectList = item;
        // },
        // 刷新表单
        resetForm() {
            if (this.$refs["dataForm"]) {
                // 清空验证信息表单
                this.$refs["dataForm"].clearValidate();
                // 刷新表单
                this.$refs["dataForm"].resetFields();
            }
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            return true;
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
            if (index !== null) {
                this.index = index;
                this.formName = "edit";
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {

                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
 
                    addData = Object.assign({}, this.formData);
                                        //Message.info("编辑");
                    investorSaveOrEdit(data, this.formName)
                        .then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            //this.$message.info(response.data.investorId);
                            this.$message.success("操作成功");
                            this.formVisible = false;
                            if (this.formName === "add") {
                                // 向头部添加数据
                                addData.investorId = response.data.investorId;
                                this.list.unshift(addData);
                            } else {
                                this.list.splice(this.index, 1, addData);
                            }
                            // 刷新表单
                            this.resetForm();
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
        // 删除
        handleDel(index, row) {
            if (row.investorId) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = { investorId: row.investorId };
                        this.deleteLoading = false;
                        investorDelete(para)
                            .then(res => {
                                this.deleteLoading = false;
                                if (res.code) {
                                    this.$message.error(res.message);
                                    return false;
                                }
                                this.$message.success("删除成功");
                                // 刷新数据
                                this.list.splice(index, 1);
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        }
    },
    filters: {},
    mounted() {
        document.body.ondrop = function(event) {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        // 加载表格数据
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss"></style>
